<div class="threejs-ayarlar-container">

  <!-- RENDER AYARLARI SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('render')">
      <i class="icon" [class.chevron-down]="sekmeler.render" [class.chevron-right]="!sekmeler.render"></i>
      <span>Render</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.render">
      <!-- 🚀 SÜREKLİ ÇİZİM MODU TOGGLE -->
      <div class="ayar-satiri checkbox-satiri" style="background: #e8f5e9; padding: 8px; border-radius: 4px; margin-bottom: 10px;">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="surekliCizimModu" (change)="kaydetAyarlar()">
          <span style="font-weight: bold; color: #2e7d32;">Sürekli Çizim Modu (Statik)</span>
        </label>
      </div>

      <div class="ayar-satiri">
        <label>Render Modu</label>
        <div class="birim-secim">
          <select [(ngModel)]="renderModu" (change)="kaydetAyarlar()" class="birim-select">
            <option value="on-demand">İsteğe Bağlı</option>
            <option value="continuous">Sürekli</option>
          </select>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Max FPS</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="maxFPS" (change)="kaydetAyarlar()" step="10" min="10" max="144" class="ayar-input">
          <span class="ayar-birimi">fps</span>
        </div>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="antialiasAktif" (change)="kaydetAyarlar()">
          <span>Anti-Alias</span>
        </label>
      </div>
    </div>
  </div>

  <!-- OPTİMİZASYON SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('optimizasyon')">
      <i class="icon" [class.chevron-down]="sekmeler.optimizasyon" [class.chevron-right]="!sekmeler.optimizasyon"></i>
      <span>Temel Optimizasyon</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.optimizasyon">
      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="frustumCullingAktif" (change)="kaydetAyarlar()">
          <span>Frustum Culling</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="lodSistemiAktif" (change)="kaydetAyarlar()">
          <span>LOD Sistemi</span>
        </label>
      </div>
    </div>
  </div>

  <!-- KAMERA SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('kamera')">
      <i class="icon" [class.chevron-down]="sekmeler.kamera" [class.chevron-right]="!sekmeler.kamera"></i>
      <span>Kamera</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.kamera">
      <div class="ayar-satiri">
        <label>Pixel Ratio</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="pixelRatio" (change)="kaydetAyarlar()" [min]="pixelRatioMin" [max]="pixelRatioMax" step="0.1" class="slider">
          <span class="ayar-degeri">{{ pixelRatio | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label class="ayar-yardimci-text">
          Ekran piksel yoğunluğu (1.0 = normal, 1.5+ = keskinleşir ama yavaşlar)
        </label>
      </div>
    </div>
  </div>

  <!-- GPU OPTIMIZATION SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('gpuOptimization')">
      <i class="icon" [class.chevron-down]="sekmeler.gpuOptimization" [class.chevron-right]="!sekmeler.gpuOptimization"></i>
      <span>GPU Optimizasyonu (TOP 5)</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.gpuOptimization">
      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="dynamicResolutionAktif" (change)="kaydetAyarlar()">
          <span>Dinamik Resolüsyon</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuParticleComputeAktif" (change)="kaydetAyarlar()">
          <span>GPU Parçacık Sistemi</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="temporalAAaktif" (change)="kaydetAyarlar()">
          <span>Zamansal Anti-Alias (TAA)</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="virtualTexturesAktif" (change)="kaydetAyarlar()">
          <span>Virtual Textures</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="shadowOptimizerAktif" (change)="kaydetAyarlar()">
          <span>Gölge Optimizatörü</span>
        </label>
      </div>
    </div>
  </div>

  <!-- GPU COMPUTE EXTREME SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('gpuCompute')">
      <i class="icon" [class.chevron-down]="sekmeler.gpuCompute" [class.chevron-right]="!sekmeler.gpuCompute"></i>
      <span>GPU Compute (EXTREME)</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.gpuCompute">
      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuPhysicsAktif" (change)="kaydetAyarlar()">
          <span>GPU Physics</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuFrustumCullingAktif" (change)="kaydetAyarlar()">
          <span>GPU Frustum Culling</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuOcclusionQueriesAktif" (change)="kaydetAyarlar()">
          <span>GPU Occlusion Queries</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuTransformFeedbackAktif" (change)="kaydetAyarlar()">
          <span>GPU Transform Feedback</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuSkinningAktif" (change)="kaydetAyarlar()">
          <span>GPU Skinning</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuParticleAdvectionAktif" (change)="kaydetAyarlar()">
          <span>GPU Parçacık Akışı</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuTextureFilteringAktif" (change)="kaydetAyarlar()">
          <span>GPU Texture Filtering</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuTileDeferredRenderingAktif" (change)="kaydetAyarlar()">
          <span>GPU Tile Deferred Rendering</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuAsyncComputeAktif" (change)="kaydetAyarlar()">
          <span>GPU Async Compute</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuStreamOutputAktif" (change)="kaydetAyarlar()">
          <span>GPU Stream Output</span>
        </label>
      </div>
    </div>
  </div>

  <!-- DEBUG AYARLARI SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('debug')">
      <i class="icon" [class.chevron-down]="sekmeler.debug" [class.chevron-right]="!sekmeler.debug"></i>
      <span>Debug Ayarları</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.debug">
      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="debugMode" (change)="kaydetAyarlar()">
          <span>Debug Modu (Console Log)</span>
        </label>
      </div>
    </div>
  </div>

  <!-- ADVANCED OPTIMIZATION SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('advancedOptimization')">
      <i class="icon" [class.chevron-down]="sekmeler.advancedOptimization" [class.chevron-right]="!sekmeler.advancedOptimization"></i>
      <span>İleri Optimizasyonlar</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.advancedOptimization">
      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="aggressiveLODAktif" (change)="kaydetAyarlar()">
          <span>Agresif LOD</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="computeWorkerPoolAktif" (change)="kaydetAyarlar()">
          <span>Compute Worker Pool</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="zPrepassAktif" (change)="kaydetAyarlar()">
          <span>Z-Prepass</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="frameBudgetAktif" (change)="kaydetAyarlar()">
          <span>Frame Budget</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="instancedOptimizerAktif" (change)="kaydetAyarlar()">
          <span>Instanced Optimizer</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="gpuDrivenRendererAktif" (change)="kaydetAyarlar()">
          <span>GPU-Driven Renderer</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="visibilityPrecomputeAktif" (change)="kaydetAyarlar()">
          <span>Visibility Precompute</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="aggressiveMergingAktif" (change)="kaydetAyarlar()">
          <span>Agresif Geometri Birleştirme</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="virtualTexturesAktif" (change)="kaydetAyarlar()">
          <span>Virtual Textures</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="neuralCompressionAktif" (change)="kaydetAyarlar()">
          <span>Neural Compression</span>
        </label>
      </div>
    </div>
  </div>

  <!-- SEÇİM VE HIGHLIGHT SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('secimVeHighlight')">
      <i class="icon" [class.chevron-down]="sekmeler.secimVeHighlight" [class.chevron-right]="!sekmeler.secimVeHighlight"></i>
      <span>Seçim & Highlight</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.secimVeHighlight">
      <div class="ayar-satiri">
        <label>Hover Rengi</label>
        <div class="renk-grup">
          <input type="color" [(ngModel)]="hoverRengi" (change)="kaydetAyarlar()" class="renk-input">
          <span class="renk-degeri">{{ hoverRengi }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Hover Opacity</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="hoverOpacity" (change)="kaydetAyarlar()" min="0" max="1" step="0.1" class="slider">
          <span class="ayar-degeri">{{ hoverOpacity | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Seçilmiş Rengi</label>
        <div class="renk-grup">
          <input type="color" [(ngModel)]="secilmisRengi" (change)="kaydetAyarlar()" class="renk-input">
          <span class="renk-degeri">{{ secilmisRengi }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Seçilmiş Opacity</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="secilmisOpacity" (change)="kaydetAyarlar()" min="0" max="1" step="0.1" class="slider">
          <span class="ayar-degeri">{{ secilmisOpacity | number:'1.1-1' }}</span>
        </div>
      </div>

      <!-- Nokta Koy Ayarları -->
      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold;">Nokta Koy Ayarları</label>
      </div>

      <div class="ayar-satiri">
        <label>Nokta Boyutu</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="noktaKoyBoyutu" (change)="kaydetAyarlar()" min="5" max="50" step="1" class="slider">
          <span class="ayar-degeri">{{ noktaKoyBoyutu | number:'1.0-0' }}px</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Hover Nokta Rengi</label>
        <div class="renk-grup">
          <input type="color" [(ngModel)]="noktaKoyHoverRengi" (change)="kaydetAyarlar()" class="renk-input">
          <span class="renk-degeri">{{ noktaKoyHoverRengi }}</span>
        </div>
      </div>

      <!-- Material Ayarları (Işıklandırma/Gölge) -->
      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold;">Material Ayarları</label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="highlightSaydamlik" (change)="kaydetAyarlar()">
          <span>Şeffaflık</span>
        </label>
      </div>

      <div class="ayar-satiri">
        <label>Pürüzlülük</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="highlightRoughness" (change)="kaydetAyarlar()" min="0" max="1" step="0.1" class="slider">
          <span class="ayar-degeri">{{ highlightRoughness | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Metaliklik</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="highlightMetalness" (change)="kaydetAyarlar()" min="0" max="1" step="0.1" class="slider">
          <span class="ayar-degeri">{{ highlightMetalness | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Işıma Yoğunluğu</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="highlightEmissiveIntensity" (change)="kaydetAyarlar()" min="0" max="1" step="0.05" class="slider">
          <span class="ayar-degeri">{{ highlightEmissiveIntensity | number:'1.2-2' }}</span>
        </div>
      </div>

      <!-- Çizgi Highlight Ayarları -->
      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold;">Çizgi Highlight Ayarları</label>
      </div>

      <div class="ayar-satiri">
        <label>Çizgi Hover Rengi</label>
        <div class="renk-grup">
          <input type="color" [(ngModel)]="cizgiHoverRengi" (change)="kaydetAyarlar()" class="renk-input">
          <span class="renk-degeri">{{ cizgiHoverRengi }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Çizgi Hover Opacity</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="cizgiHoverOpacity" (change)="kaydetAyarlar()" min="0" max="1" step="0.1" class="slider">
          <span class="ayar-degeri">{{ cizgiHoverOpacity | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Çizgi Seçilmiş Rengi</label>
        <div class="renk-grup">
          <input type="color" [(ngModel)]="cizgiSecilmisRengi" (change)="kaydetAyarlar()" class="renk-input">
          <span class="renk-degeri">{{ cizgiSecilmisRengi }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Çizgi Seçilmiş Opacity</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="cizgiSecilmisOpacity" (change)="kaydetAyarlar()" min="0" max="1" step="0.1" class="slider">
          <span class="ayar-degeri">{{ cizgiSecilmisOpacity | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Çizgi Kalınlığı</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="cizgiKalinligi" (change)="kaydetAyarlar()" min="1" max="20" step="0.5" class="slider">
          <span class="ayar-degeri">{{ cizgiKalinligi | number:'1.1-1' }}</span>
        </div>
      </div>

      <!-- Kenar Ayarları -->
      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold;">Kenar Ayarları</label>
      </div>

      <div class="ayar-satiri">
        <label>Kenar Gücü</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="kenarGucluklagi" (change)="kaydetAyarlar()" min="0" max="30" step="0.5" class="slider">
          <span class="ayar-degeri">{{ kenarGucluklagi | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Kenar Yoğunluğu</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="kenarYogunluklagi" (change)="kaydetAyarlar()" min="0" max="5" step="0.1" class="slider">
          <span class="ayar-degeri">{{ kenarYogunluklagi | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Kenar Kalınlığı</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="kenarKalinligi" (change)="kaydetAyarlar()" min="0.1" max="5" step="0.1" class="slider">
          <span class="ayar-degeri">{{ kenarKalinligi | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Görünür Kenar Rengi</label>
        <div class="renk-grup">
          <input type="color" [(ngModel)]="gorunurKenarRengi" (change)="kaydetAyarlar()" class="renk-input">
          <span class="renk-degeri">{{ gorunurKenarRengi }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Gizli Kenar Rengi</label>
        <div class="renk-grup">
          <input type="color" [(ngModel)]="gizliKenarRengi" (change)="kaydetAyarlar()" class="renk-input">
          <span class="renk-degeri">{{ gizliKenarRengi }}</span>
        </div>
      </div>

      <!-- Hover Highlight Tip Ayarları -->
      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold;">Hover Highlight Tipleri</label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="hoverHighlightMesh" (change)="kaydetAyarlar()">
          <span>Mesh (Yüzey)</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="hoverHighlightLine" (change)="kaydetAyarlar()">
          <span>Line (Çizgi)</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="hoverHighlightPoint" (change)="kaydetAyarlar()">
          <span>Point (Nokta)</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="hoverHighlightEdge" (change)="kaydetAyarlar()">
          <span>Edge (Kenar)</span>
        </label>
      </div>

      <div class="ayar-satiri" style="color: #666; font-size: 0.9em;">
        <label class="ayar-yardimci-text">
          Hangi nesne tiplerinin üzerine gelindiğinde highlight olacağını seçin
        </label>
      </div>

      <!-- Seçim Highlight Tip Ayarları -->
      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold;">Seçim Highlight Tipleri</label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="selectionHighlightMesh" (change)="kaydetAyarlar()">
          <span>Mesh (Yüzey)</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="selectionHighlightLine" (change)="kaydetAyarlar()">
          <span>Line (Çizgi)</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="selectionHighlightPoint" (change)="kaydetAyarlar()">
          <span>Point (Nokta)</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="selectionHighlightEdge" (change)="kaydetAyarlar()">
          <span>Edge (Kenar)</span>
        </label>
      </div>

      <div class="ayar-satiri" style="color: #666; font-size: 0.9em;">
        <label class="ayar-yardimci-text">
          Hangi nesne tiplerinin tıklandığında highlight olacağını seçin
        </label>
      </div>

      <!-- Kenar/Nokta Seçim Ayarları (2D Piksel Tabanlı) -->
      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold;">Kenar/Nokta Seçim (2D Piksel)</label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="pikselTabanliSecimAktif" (change)="kaydetAyarlar()">
          <span>2D Piksel Tabanlı Seçim (Master)</span>
        </label>
      </div>

      <!-- Ayrı Seçim Tipleri -->
      <div *ngIf="pikselTabanliSecimAktif" style="margin-left: 15px; border-left: 2px solid #ddd; padding-left: 10px;">
        <div class="ayar-satiri checkbox-satiri">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="noktaSecimAktif" (change)="kaydetAyarlar()">
            <span>Nokta Seçimi</span>
          </label>
        </div>

        <div class="ayar-satiri checkbox-satiri">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="kenarSecimAktif" (change)="kaydetAyarlar()">
            <span>Kenar (Edge) Seçimi</span>
          </label>
        </div>

        <div class="ayar-satiri checkbox-satiri">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="yuzeySecimAktif" (change)="kaydetAyarlar()">
            <span>Yüzey (Mesh) Seçimi</span>
          </label>
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="pikselTabanliSecimAktif && kenarSecimAktif">
        <label>Kenar Seçim Toleransı</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="kenarSecimPikselToleransi" (change)="kaydetAyarlar()" min="0.1" max="60" step="0.1" class="slider">
          <span class="ayar-degeri">{{ kenarSecimPikselToleransi | number:'1.1-1' }}px</span>
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="pikselTabanliSecimAktif && noktaSecimAktif">
        <label>Nokta Seçim Toleransı</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="noktaSecimPikselToleransi" (change)="kaydetAyarlar()" min="0.1" max="60" step="0.1" class="slider">
          <span class="ayar-degeri">{{ noktaSecimPikselToleransi | number:'1.1-1' }}px</span>
        </div>
      </div>

      <div class="ayar-satiri checkbox-satiri" *ngIf="pikselTabanliSecimAktif">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="akilliOncelikAktif" (change)="kaydetAyarlar()">
          <span>Akıllı Öncelik (yüzey varken sıkı tolerans)</span>
        </label>
      </div>

      <div class="ayar-satiri" *ngIf="pikselTabanliSecimAktif && akilliOncelikAktif">
        <label>Yüzey Üzerinde Eşik</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="yuzeyOncelikEsigi" (change)="kaydetAyarlar()" min="0.1" max="30" step="0.1" class="slider">
          <span class="ayar-degeri">{{ yuzeyOncelikEsigi | number:'1.1-1' }}px</span>
        </div>
      </div>

      <div class="ayar-satiri checkbox-satiri" *ngIf="pikselTabanliSecimAktif">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="cizgiOncelikliSecim" (change)="kaydetAyarlar()">
          <span>Çizgi Öncelikli Seçim (yüzey üzerinde bile)</span>
        </label>
      </div>

      <div class="ayar-satiri" *ngIf="pikselTabanliSecimAktif" style="color: #666; font-size: 0.9em;">
        <label class="ayar-yardimci-text">
          Yüksek değer = kolay seçim, düşük değer = hassas seçim
        </label>
      </div>

      <!-- PERFORMANS AYARLARI (Büyük Dosyalar İçin) -->
      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold; color: #e74c3c;">Performans (Büyük STP)</label>
      </div>

      <div class="ayar-satiri">
        <label>Hover Throttle</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="hoverThrottleMs" (change)="kaydetAyarlar()" min="8" max="100" step="1" class="slider">
          <span class="ayar-degeri">{{ hoverThrottleMs }}ms</span>
        </div>
      </div>

      <div class="ayar-satiri" style="color: #666; font-size: 0.85em;">
        <label class="ayar-yardimci-text">
          16ms=60fps, 33ms=30fps, 50ms=20fps (Kasar ise artır)
        </label>
      </div>

      <div class="ayar-satiri">
        <label>Max Edge Objesi</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="maxEdgeObjesiSayisi" (change)="kaydetAyarlar()" min="50" max="2000" step="50" class="slider">
          <span class="ayar-degeri">{{ maxEdgeObjesiSayisi }}</span>
        </div>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="frustumCullingAktif" (change)="kaydetAyarlar()">
          <span>Frustum Culling (görünmeyen atla)</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="uzaklikFiltreAktif" (change)="kaydetAyarlar()">
          <span>Uzaklık Filtresi</span>
        </label>
      </div>

      <div class="ayar-satiri" *ngIf="uzaklikFiltreAktif">
        <label>Uzaklık Eşiği</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="uzaklikFiltreEsigi" (change)="kaydetAyarlar()" min="100" max="5000" step="100" class="slider">
          <span class="ayar-degeri">{{ uzaklikFiltreEsigi }}</span>
        </div>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="erkenCikisAktif" (change)="kaydetAyarlar()">
          <span>Erken Çıkış (yakın bulunca dur)</span>
        </label>
      </div>

      <div class="ayar-satiri" *ngIf="erkenCikisAktif">
        <label>Erken Çıkış Mesafesi</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="erkenCikisMesafesi" (change)="kaydetAyarlar()" min="1" max="20" step="1" class="slider">
          <span class="ayar-degeri">{{ erkenCikisMesafesi }}px</span>
        </div>
      </div>

      <!-- DEBUG AYARLARI -->
      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold;">Debug Ayarları</label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="debugMode" (change)="kaydetAyarlar()">
          <span>Debug Modu (Console Log)</span>
        </label>
      </div>
    </div>
  </div>

  <!-- ÖLÇÜM AYARLARI SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('olcum')">
      <i class="icon" [class.chevron-down]="sekmeler.olcum" [class.chevron-right]="!sekmeler.olcum"></i>
      <span>Ölçüm Ayarları</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.olcum">
      <div class="ayar-satiri">
        <label>Çizgi Rengi</label>
        <div class="renk-grup">
          <input type="color" [(ngModel)]="olcumCizgiRengi" (change)="kaydetAyarlar()" class="renk-input">
          <span class="renk-degeri">{{ olcumCizgiRengi }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Çizgi Kalınlığı</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="olcumCizgiKalinligi" (change)="kaydetAyarlar()" min="1" max="10" step="0.5" class="slider">
          <span class="ayar-degeri">{{ olcumCizgiKalinligi | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Offset Mesafesi</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="olcumOffsetMesafe" (change)="kaydetAyarlar()" min="5" max="50" step="1" class="slider">
          <span class="ayar-degeri">{{ olcumOffsetMesafe | number:'1.0-0' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Yazı Boyutu</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="olcumYaziFontSize" (change)="kaydetAyarlar()" min="10" max="36" step="1" class="slider">
          <span class="ayar-degeri">{{ olcumYaziFontSize | number:'1.0-0' }}px</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Yazı Rengi</label>
        <div class="renk-grup">
          <input type="color" [(ngModel)]="olcumYaziRengi" (change)="kaydetAyarlar()" class="renk-input">
          <span class="renk-degeri">{{ olcumYaziRengi }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Yazı Arka Plan Şeffaflığı</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="olcumYaziBackgroundAlpha" (change)="kaydetAyarlar()" min="0" max="1" step="0.1" class="slider">
          <span class="ayar-degeri">{{ olcumYaziBackgroundAlpha | number:'1.1-1' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- RAYCAST AYARLARI SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('raycast')">
      <i class="icon" [class.chevron-down]="sekmeler.raycast" [class.chevron-right]="!sekmeler.raycast"></i>
      <span>Raycast (Seçim Hassasiyeti)</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.raycast">
      <div class="ayar-satiri">
        <label>Profil Seç</label>
        <div class="birim-secim">
          <select [(ngModel)]="raycastProfili" (change)="raycastProfiliniDegistir(raycastProfili)" class="birim-select">
            <option *ngFor="let profil of raycastProfilListi; let i = index" [value]="profil">
              {{ profil }}
            </option>
          </select>
        </div>
      </div>

      <div class="ayar-satiri" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
        <label style="font-weight: bold;">Threshold Ayarları</label>
      </div>

      <div class="ayar-satiri">
        <label>Mesh Threshold</label>
        <div class="deger-grup">
          <input type="range"
                 [ngModel]="mevcut_raycast_config.meshThreshold"
                 (change)="raycastThresholdGuncelle('meshThreshold', $any($event).target.value)"
                 min="0" max="10" step="0.1" class="slider">
          <span class="ayar-degeri">{{ mevcut_raycast_config.meshThreshold | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Line Threshold</label>
        <div class="deger-grup">
          <input type="range"
                 [ngModel]="mevcut_raycast_config.lineThreshold"
                 (change)="raycastThresholdGuncelle('lineThreshold', $any($event).target.value)"
                 min="0" max="10" step="0.1" class="slider">
          <span class="ayar-degeri">{{ mevcut_raycast_config.lineThreshold | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Points Threshold</label>
        <div class="deger-grup">
          <input type="range"
                 [ngModel]="mevcut_raycast_config.pointsThreshold"
                 (change)="raycastThresholdGuncelle('pointsThreshold', $any($event).target.value)"
                 min="0" max="10" step="0.1" class="slider">
          <span class="ayar-degeri">{{ mevcut_raycast_config.pointsThreshold | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Sprite Threshold</label>
        <div class="deger-grup">
          <input type="range"
                 [ngModel]="mevcut_raycast_config.spriteThreshold"
                 (change)="raycastThresholdGuncelle('spriteThreshold', $any($event).target.value)"
                 min="0" max="10" step="0.1" class="slider">
          <span class="ayar-degeri">{{ mevcut_raycast_config.spriteThreshold | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>LOD Threshold</label>
        <div class="deger-grup">
          <input type="range"
                 [ngModel]="mevcut_raycast_config.lodThreshold"
                 (change)="raycastThresholdGuncelle('lodThreshold', $any($event).target.value)"
                 min="0" max="10" step="0.1" class="slider">
          <span class="ayar-degeri">{{ mevcut_raycast_config.lodThreshold | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri" style="color: #666; font-size: 0.9em; margin-top: 10px;">
        <label class="ayar-yardimci-text">
          0 = Algılanmaz | 0.1 = Hassas (ince çizgiler) | 0.5 = Normal | 1.0+ = Geniş
        </label>
      </div>
    </div>
  </div>

  <!-- BUTONLAR -->
  <div class="ayarlar-butonlari">
    <button class="ui mini button" (click)="kaydetAyarlar()" title="Ayarları kaydet">
      <i class="icon save"></i>Kaydet
    </button>
    <button class="ui mini button" (click)="resetAyarlar()" title="Varsayılana dön">
      <i class="icon refresh"></i>Sıfırla
    </button>
    <button class="ui mini button" (click)="kapat()" title="Dialogu kapat">
      <i class="icon close"></i>Kapat
    </button>
  </div>

</div>
